import {
  AfterViewInit,
  Component,
  ContentChild,
  Input,
  ViewChild,
  ChangeDetectorRef,
  HostBinding,
  Output,
  EventEmitter,
  Optional,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ControlContainer, NgForm } from '@angular/forms';
import { MatDateRangeInput } from '@angular/material/datepicker';
import { MatFormField, MatFormFieldAppearance, MatFormFieldControl } from '@angular/material/form-field';

import { SedsFormControlType } from '../../seds-form-field/models/seds-form-control-type.model';
import { SedsFormFieldType } from '../../seds-form-field/enums/seds-form-field-type.enum';
import { SedsFormFieldOptionsType } from '../../seds-form-field/types/seds-form-field-options.type';
import { SedsPositionsOptions } from '../../../shared/enums/seds-positions-options.enum';
import { SedsPositionsOptionsType } from '../../../shared/types/seds-positions-options.type';
import { SedsThemeColorOptionsType } from '../../../shared/types/seds-theme-color-options.type';
import { SedsThemeColorOptions } from '../../../shared/enums/seds-theme-color-options.enum';

@Component({
    selector: 'seds-form-field-core',
    templateUrl: './seds-form-field-core.component.html',
    styleUrls: ['./seds-form-field-core.component.scss'],
    viewProviders: [{ provide: ControlContainer, deps: [[Optional, NgForm]], useFactory: (ngForm: NgForm) => ngForm }],
    standalone: false
})
export class SedsFormFieldCoreComponent implements AfterViewInit {
  @Input() color?: SedsThemeColorOptions | SedsThemeColorOptionsType = SedsThemeColorOptions.DEFAULT;
  @Input() hint?: string;
  @Input() iconLabel?: string;
  @Input() iconName?: string;
  @Input() iconPosition?: SedsPositionsOptions | SedsPositionsOptionsType;
  @Input() label?: string;
  @Input() selectFieldIcon = '';
  @Input() selectedFieldIconLabel?: string;
  @Input() sendedControl!: MatFormFieldControl<any>;
  @Input() set type(value: SedsFormFieldType | SedsFormFieldOptionsType) {
    this._type = value;
    this.hostClass = value;
  }
  @Input() warningColor = false;

  @Output() iconAction = new EventEmitter<void>();

  @ContentChild(MatFormFieldControl) matFormControl!: MatFormFieldControl<unknown>;
  @HostBinding('class') hostClass = '';
  @ViewChild(MatFormField) matFormField!: MatFormField;

  appearance: MatFormFieldAppearance = 'outline';
  _type?: SedsFormFieldType | SedsFormFieldOptionsType;

  public endNgControl!: SedsFormControlType;
  public isBeforeViewInit$$ = new BehaviorSubject(true);
  public isRangeInput = false;
  public ngControl!: SedsFormControlType;
  public startNgControl!: SedsFormControlType;
  public floatLabelText = false;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.isRangeInput = this.checkDatepickerInputType();
    this.matFormField._control = this.sendedControl || this.matFormControl;
    if (this.isRangeInput) {
      const rangeInput = this.matFormControl as MatDateRangeInput<Date>;
      this.startNgControl = rangeInput._startInput.ngControl;
      this.endNgControl = rangeInput._endInput.ngControl;
      this.ngControl = this.matFormField._control.ngControl;
    } else {
      this.ngControl = this.matFormField._control.ngControl;
    }
    this.matFormField.ngAfterContentInit();
    this.isBeforeViewInit$$.next(false);
    this.floatLabel();
    this.cdr.detectChanges();
  }

  handleIconClick() {
    this.iconAction.emit();
  }

  floatLabel() {
    this.floatLabelText = this.matFormField._control.value;
  }

  handleIconKeyboardEvent(event: KeyboardEvent) {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      this.iconAction.emit();
    }
  }

  checkDatepickerInputType(): boolean {
    return (
      (this.matFormControl && this.matFormControl.controlType === 'mat-date-range-input') ||
      (this.sendedControl && this.sendedControl.controlType === 'mat-date-range-input')
    );
  }
}
